<template>
  <div>
    <NText variant="body">
      {{
        t('modules.portfolio.embeddedPutOption.deleteMessage', {
          instrumentName: instrumentName,
        })
      }}
    </NText>

    <div class="flex mt-6">
      <NButton
        variant="plain"
        color="gray"
        class="flex-[1] ml-6"
        @click="removeDialog()"
      >
        {{ t('common.cancel') }}
      </NButton>

      <NButton
        class="flex-[1]"
        color="red"
        :disabled="isLoadingDeleteEmbeddedPutOptionRequest"
        @click="handleDelete"
      >
        {{ t('modules.portfolio.embeddedPutOption.deleteButtonTitle') }}
      </NButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useDialog, useToast } from '@negar/core';
import {
  PORTFOLIO_QUERY_KEYS,
  useDeleteEmbeddedPutOptionRequestQuery,
} from '@core/portfolio';
import { useQueryClient } from '@libs/use';

type EmbeddedPutOptionInfoDialogPropsType = {
  instrumentIsin: string;
  instrumentName: string;
};

const props = defineProps<EmbeddedPutOptionInfoDialogPropsType>();

const { t } = useI18n();

const queryClient = useQueryClient();

const toast = useToast();
const { remove: removeDialog } = useDialog();

const {
  deleteEmbeddedPutOptionRequest,
  isLoadingDeleteEmbeddedPutOptionRequest,
} = useDeleteEmbeddedPutOptionRequestQuery({
  onSuccess: () => {
    toast.neutral({
      message: t('modules.portfolio.embeddedPutOption.deleteSuccessMessage', {
        instrumentName: props.instrumentName,
      }),
      duration: 3000,
    });

    queryClient.invalidateQueries(
      PORTFOLIO_QUERY_KEYS.embeddedPutOptionSymbols
    );

    removeDialog();
  },
  onReject: () => {
    toast.negative({
      message: t('modules.portfolio.embeddedPutOption.deleteErrorMessage', {
        instrumentName: props.instrumentName,
      }),
      duration: 3000,
    });
  },
});

const handleDelete = () =>
  deleteEmbeddedPutOptionRequest({ isin: props.instrumentIsin });
</script>
